import { FloatingContainer, Screen, Text } from '~/commonComponents';

export const CandidateOverview = () => {
  return (
    <Screen>
      <FloatingContainer borderRadius={0} flex={1}>
        <Text>TBD</Text>
      </FloatingContainer>
    </Screen>
  );
};
